// extracted by mini-css-extract-plugin
export default {"createLoadFrame":"VehicleLoad_createLoadFrame__sZVjO","createLoadFrameContent":"VehicleLoad_createLoadFrameContent__P0CS9","loadFrameButtons":"VehicleLoad_loadFrameButtons__M-qah"};